module.exports = __webpack_public_path__ + "static/media/walk_kids_map.6afffa87.svg";